// actionTypes.js
export const SET_VALUE_CGP = "SET_VALUE_CGP";
export const SET_TYPE_CGP = "SET_TYPE_CGP";
export const SET_CURRENT_PAGE_CGP = "SET_CURRENT_PAGE_CGP";
export const SET_ORDER_CGP = "SET_ORDER_CGP";
export const SET_SORT_FIELD_CGP = "SET_SORT_FIELD_CGP";
export const SET_ACTIF_CGP = "SET_ACTIF_CGP";
